/* Dalia Bella · comportamiento común de las secciones nuevas (retoque 30-10-2026).
   - Carrusel: [data-db-car] con [data-db-pista], [data-db-prev], [data-db-next] y [data-db-barra].
   - Visor de fotos: enlaces [data-db-foto] (href = foto grande, data-db-pie opcional), agrupados por [data-db-galeria].
   - Añadir al carrito: botones [data-db-add] (data-variant, o un <select data-db-variante> dentro del mismo [data-db-item]).
   - Mostrar/ocultar: botones [data-db-mostrar="<selector>"] alternan la clase db-abierto en el destino. */
(function () {
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Carrusel */
  function iniciarCarrusel(c) {
    if (c.dataset.dbListo) return;
    c.dataset.dbListo = '1';
    var pista = c.querySelector('[data-db-pista]');
    if (!pista) return;
    var ant = c.querySelector('[data-db-prev]');
    var sig = c.querySelector('[data-db-next]');
    var barra = c.querySelector('[data-db-barra]');
    var cuenta = c.querySelector('[data-db-cuenta]');
    function paso() {
      var it = pista.firstElementChild;
      var gap = parseFloat(getComputedStyle(pista).columnGap) || 0;
      return it ? it.getBoundingClientRect().width + gap : pista.clientWidth;
    }
    function mover(n) { pista.scrollBy({ left: paso() * n, behavior: reducido ? 'auto' : 'smooth' }); }
    function actualizar() {
      var max = pista.scrollWidth - pista.clientWidth;
      var x = pista.scrollLeft;
      if (ant) ant.disabled = x <= 2;
      if (sig) sig.disabled = x >= max - 2;
      if (barra) barra.style.setProperty('--db-prog', max > 0 ? (x / max).toFixed(3) : 1);
      if (cuenta) {
        var total = pista.children.length;
        var i = x >= max - 2 ? total - 1 : Math.round(x / paso());
        cuenta.textContent = Math.min(i + 1, total) + ' / ' + total;
      }
      c.classList.toggle('db-car--sin-scroll', max <= 2);
    }
    if (ant) ant.addEventListener('click', function () { mover(-1); });
    if (sig) sig.addEventListener('click', function () { mover(1); });
    pista.addEventListener('scroll', actualizar, { passive: true });
    window.addEventListener('resize', actualizar);
    actualizar();
  }
  function iniciarTodo(raiz) { (raiz || document).querySelectorAll('[data-db-car]').forEach(iniciarCarrusel); }

  /* Visor de fotos */
  var visor = null, fotos = [], actual = 0;
  function crearVisor() {
    visor = document.createElement('dialog');
    visor.className = 'db-lb';
    visor.setAttribute('aria-label', 'Foto ampliada');
    visor.innerHTML = '<div class="db-lb__marco"><img class="db-lb__img" alt=""><p class="db-lb__pie"></p>' +
      '<button type="button" class="db-lb__ant" aria-label="Foto anterior">‹</button>' +
      '<button type="button" class="db-lb__sig" aria-label="Foto siguiente">›</button>' +
      '<button type="button" class="db-lb__x" aria-label="Cerrar">×</button></div>';
    document.body.appendChild(visor);
    visor.querySelector('.db-lb__x').addEventListener('click', function () { visor.close(); });
    visor.querySelector('.db-lb__ant').addEventListener('click', function () { ver(actual - 1); });
    visor.querySelector('.db-lb__sig').addEventListener('click', function () { ver(actual + 1); });
    visor.addEventListener('click', function (e) { if (e.target === visor || e.target.classList.contains('db-lb__marco')) visor.close(); });
    visor.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') ver(actual - 1);
      if (e.key === 'ArrowRight') ver(actual + 1);
    });
  }
  function ver(i) {
    if (!fotos.length) return;
    actual = (i + fotos.length) % fotos.length;
    var a = fotos[actual];
    var img = visor.querySelector('.db-lb__img');
    img.src = a.getAttribute('href');
    img.alt = a.dataset.dbAlt || '';
    visor.querySelector('.db-lb__pie').textContent = a.dataset.dbPie || '';
    var varias = fotos.length > 1;
    visor.querySelector('.db-lb__ant').hidden = !varias;
    visor.querySelector('.db-lb__sig').hidden = !varias;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-db-foto]');
    if (!a) return;
    e.preventDefault();
    if (!visor) crearVisor();
    var grupo = a.closest('[data-db-galeria]');
    fotos = grupo ? Array.prototype.slice.call(grupo.querySelectorAll('[data-db-foto]')) : [a];
    ver(fotos.indexOf(a));
    if (!visor.open) visor.showModal();
  });

  /* Añadir al carrito con el evento estándar de Horizon (repinta el carrito y lo abre si el tema lo tiene activado) */
  var eventos = null;
  try { eventos = import('@shopify/events').catch(function () { return null; }); } catch (x) { eventos = Promise.resolve(null); }

  function aviso(item, texto) {
    var p = item && item.querySelector('[data-db-aviso]');
    if (p) p.textContent = texto || '';
  }
  function anadir(btn) {
    var item = btn.closest('[data-db-item]') || btn.parentElement;
    var sel = item && item.querySelector('[data-db-variante]');
    var id = sel ? sel.value : btn.dataset.variant;
    if (!id) {
      if (sel) { sel.classList.add('db-falta'); sel.focus(); }
      aviso(item, btn.dataset.dbFalta || 'Elige tu talla');
      return;
    }
    if (sel) sel.classList.remove('db-falta');
    aviso(item, '');
    var texto = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Agregando…';
    var secciones = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (x) { return x.dataset.sectionId; })
      .filter(Boolean).join(',');

    eventos.then(function (m) {
      var Ev = m && m.CartLinesUpdateEvent;
      var dif = Ev ? Ev.createPromise() : null;
      if (Ev) {
        btn.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: dif.promise }));
      }
      var cuerpo = { items: [{ id: Number(id), quantity: 1 }] };
      if (secciones) cuerpo.sections = secciones;
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok && !j.status, j: j }; }); })
        .then(function (res) {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (carrito) {
            if (dif) {
              dif.resolve({
                cart: Ev.createCartFromAjaxResponse(carrito),
                detail: { items: carrito.items, source: 'dalia-ui', itemCount: 1, sections: res.j.sections, didError: !res.ok },
              });
            }
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'No se pudo agregar');
            if (!dif) { try { sessionStorage.setItem('db-abrir-carrito', '1'); } catch (x) {} location.reload(); return; }
            btn.classList.add('is-ok');
            btn.textContent = '✓ Agregado';
            setTimeout(function () { btn.classList.remove('is-ok'); btn.innerHTML = texto; btn.disabled = false; }, 2400);
          });
        });
    }).catch(function (err) {
      btn.innerHTML = texto;
      btn.disabled = false;
      aviso(item, (err && err.message) || 'No se pudo agregar. Inténtalo de nuevo.');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-db-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    anadir(b);
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-db-variante]')) {
      e.target.classList.remove('db-falta');
      aviso(e.target.closest('[data-db-item]'), '');
    }
  });

  /* Mostrar / ocultar */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-db-mostrar]');
    if (!b) return;
    var t = document.querySelector(b.dataset.dbMostrar);
    if (!t) return;
    var abrir = !t.classList.contains('db-abierto');
    t.classList.toggle('db-abierto', abrir);
    b.setAttribute('aria-expanded', String(abrir));
    if (b.dataset.dbTextoAbierto) {
      if (!b.dataset.dbTextoCerrado) b.dataset.dbTextoCerrado = b.textContent;
      b.textContent = abrir ? b.dataset.dbTextoAbierto : b.dataset.dbTextoCerrado;
    }
    if (abrir && b.dataset.dbIr !== 'no') t.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciarTodo(); });
  else iniciarTodo();
  document.addEventListener('shopify:section:load', function (e) { iniciarTodo(e.target); });
})();
